module.exports = __webpack_public_path__ + "img/9788958280255.3cd81a94.jpg";